import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { relativePaths } from '@app/constants';
import _ from 'lodash';
import { Store } from '@ngrx/store';
import { createMapUrl } from '@app/utils';
import { Subscription } from 'rxjs';
import { waterwaysActions, waterwaysSelector, waterwaysState } from '@app/core/store/waterways/waterways.slice';
import { FilterWaterwaysPayload } from '@app/core/features/waterways/waterway.payload';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

@Component({
  selector: 'dialog-search-waterways',
  templateUrl: './dialog-search-waterways.html',
  styleUrls: ['./dialog-search-waterways.scss'],
  providers: [{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig }],
})
export class DialogSearchWaterways implements OnInit, OnDestroy {
  maxResults = 20;
  skip = 0;
  searchText = '';
  filterWaterways: any;
  filterWaterways$: any;
  filterWaterwaysSubs: Subscription;

  constructor(
    private store: Store<{}>,
    private router: Router,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogSearchWaterways>,
  ) {}

  ngOnInit() {
    this.filterWaterways$ = this.store.select(waterwaysSelector.filterWaterways);
    this.filterWaterwaysSubs = this.store.select(waterwaysSelector.filterWaterways).subscribe(response => {
      this.filterWaterways = response;
    });
  }

  ngOnDestroy(): void {
    this.filterWaterwaysSubs.unsubscribe();
    this.store.dispatch(waterwaysActions.cleanState(waterwaysState.filterWaterways));
  }

  closeModal() {
    this.dialogRef.close();
  }

  handleFollow() {
    this.dialogRef.close();
    this.router.navigate([relativePaths.SIGN_UP]);
  }

  navigateWaterway(waterway) {
    this.dialogRef.close();
    this.router.navigate([createMapUrl(waterway)]);
  }

  searchWaterways = () => {
    if (!this.filterWaterways.isLoading && (!this.filterWaterways.result || this.filterWaterways.length > 0)) {
      const { query, skip, maxResults } = this.filterWaterways.payload;
      this.store.dispatch(waterwaysActions.filterWaterways(new FilterWaterwaysPayload(query, maxResults, skip + maxResults)));
    }
  };
}
